import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { Loader2 } from 'lucide-react'; // Assuming you use lucide-react for icons

const AdminRoute: React.FC = () => {
  const { user, isAdmin, loading } = useAuth();

  if (loading) {
    // Optional: Show a loading spinner while checking auth state
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    // Not logged in, redirect to login page
    // Pass the current location to redirect back after login (optional)
    return <Navigate to="/auth" replace />;
  }

  if (!isAdmin) {
    // Logged in but not an admin, redirect to dashboard or home
    // Consider showing a 'Not Authorized' message instead
    return <Navigate to="/dashboard" replace />;
  }

  // User is logged in and is an admin, render the nested routes
  return <Outlet />;
};

export default AdminRoute;
